import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TrainingQualificationRow } from '@wilson/interfaces';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzGridModule } from 'ng-zorro-antd/grid';

@Component({
  selector: 'wilson-training-qualifications-footer-section',
  imports: [NzButtonModule, TranslatePipe, NzGridModule],
  templateUrl: './training-qualifications-footer-section.component.html',
  styleUrl: './training-qualifications-footer-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrainingQualificationsFooterSectionComponent {
  @Input() cancelTranslationKey = 'general.cancel';
  @Input() saveTranslationKey = 'general.save';

  @Input() saveButtonDisabled = false;
  @Input() loading: boolean | null = false;
  @Input() numberOfTrainings = 0;
  @Input() numEmployees = 0;
  @Input() validRows: TrainingQualificationRow[] = [];

  @Output() cancelDrawer = new EventEmitter<void>();
  @Output() saveDrawer = new EventEmitter<void>();

  protected cancelDrawerAction(): void {
    this.cancelDrawer.emit();
  }

  protected saveDrawerAction(): void {
    this.saveDrawer.emit();
  }

  protected get numQualifications(): number {
    return (
      this.validRows.reduce((acc, row) => {
        return acc + (row.qualifications?.length ?? 0);
      }, 0) * this.numEmployees
    );
  }
}
